"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-laptop.tsx
var Laptop = function Laptop(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("rect", {
    x: "3.33398",
    y: "5",
    width: "13.3333",
    height: "9.16667",
    rx: "1",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M1.66602 14.1665H18.3327L17.7757 15.2804C17.6064 15.6192 17.2601 15.8332 16.8813 15.8332H3.11738C2.73861 15.8332 2.39235 15.6192 2.22296 15.2804L1.66602 14.1665Z",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = Laptop;
exports.default = _default;